"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.HOTJAR_TRIGGER = exports.HOTJAR_TAG_RECORDING = exports.GA_SET = exports.GA_SEND = exports.GA_PAGEVIEW = exports.GA_EVENT = exports.GA_CLIENTID = void 0;
var GA_SEND = 'send';
exports.GA_SEND = GA_SEND;
var GA_SET = 'set';
exports.GA_SET = GA_SET;
var GA_CLIENTID = 'clientId';
exports.GA_CLIENTID = GA_CLIENTID;
var GA_EVENT = 'event';
exports.GA_EVENT = GA_EVENT;
var GA_PAGEVIEW = 'pageview';
exports.GA_PAGEVIEW = GA_PAGEVIEW;
var HOTJAR_TRIGGER = 'trigger';
exports.HOTJAR_TRIGGER = HOTJAR_TRIGGER;
var HOTJAR_TAG_RECORDING = 'tagRecording';
exports.HOTJAR_TAG_RECORDING = HOTJAR_TAG_RECORDING;
var _default = {
  GA_SEND: GA_SEND,
  GA_SET: GA_SET,
  GA_EVENT: GA_EVENT,
  GA_PAGEVIEW: GA_PAGEVIEW,
  HOTJAR_TRIGGER: HOTJAR_TRIGGER,
  HOTJAR_TAG_RECORDING: HOTJAR_TAG_RECORDING
};
exports.default = _default;
//# sourceMappingURL=constants.js.map